import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TopnavService {
  openChat!: EventEmitter<null>;

  constructor() {
    this.openChat = new EventEmitter();
  }
}
